import actions from "../../constants/actions";
import Schemas from "../models";
import { normalize } from "normalizr";

export const manualUser = (user) => {
    return {
        type: actions.LOAD_USER_ME_SUCCESS,
        payload: normalize({ data: user }, Schemas.USER),
    };
};

export const loadUserMe = () => {
    return {
        type: actions.LOAD_USER_ME,
        payload: {
            options: {},
        },
    };
};

export const updateUserMe = (data) => {
    return {
        type: actions.UPDATE_USER_ME,
        payload: {
            data,
        },
    };
};

export const deleteUserMe = () => {
    return {
        type: actions.DELETE_USER_ME,
        payload: {},
    };
};
